import { Component, OnInit, Input } from '@angular/core';
import { CommercialOrderStatus } from 'src/app/core/enumerations/commercial-order-status';
import { Constants, DrawChoice } from '../constants';

@Component({
    selector: 'app-order-status-bar',
    templateUrl: './order-status-bar.component.html',
    styleUrls: ['./order-status-bar.component.scss'],
    standalone: false
})
export class OrderStatusBarComponent implements OnInit {

  private static readonly FILE_MEDICAL_ICON = "fa-solid fa-file-medical";
  private static readonly TRUCK_DROPLET_ICON = "fa-solid fa-truck-droplet";
  private static readonly FLASK_VIAL_ICON = "fa-solid fa-flask-vial";
  private static readonly FILE_LINES_ICON = "fa-solid fa-file-lines";
  private static readonly ORDER_PLACED_LABEL = 'Order placed';
  private static readonly SAMPLE_COLLECTED_LABEL = 'Sample collected';
  private static readonly SAMPLE_RECEIVED_AT_LAB_LABEL = 'Sample received at lab';
  private static readonly KIT_SENT_TO_PATIENT_LABEL = 'Kit sent to patient';
  private static readonly MOBILE_DRAW_SCHEDULE_PENDING_LABEL = 'Mobile Draw schedule pending';
  private static readonly THIRD_PARTY_DRAW_PENDING_LABEL = 'Third Party Draw pending';

  constructor() { }

 @Input() drawChoice = ''; 
 @Input() currentStatus = '';
 @Input() buCode = '';
 steps: {name: string, label: string; icon: string, isActive: boolean}[] = [];
 
 ngOnInit() {
   this.currentStatus= this.UpdateCompletedStatus(this.currentStatus)
   const statusSteps = this.deriveStatusBasedonDrawChoice(this.drawChoice, this.currentStatus);

   const currentStepIndex = statusSteps.findIndex(s=> s.name===this.currentStatus);
   this.steps = statusSteps.map((step, index) => ({...step, isActive: currentStepIndex >= index}) )
 }

 deriveStatusBasedonDrawChoice(drawChoice : string, status: string){
  let  statusSteps: {name: string, label: string; icon: string}[] = [];
  if (drawChoice?.toLowerCase() === DrawChoice.ScheduledInClinic.toLowerCase() || (this.isFieldNullOrEmpty(drawChoice) && this.buCode === Constants.BUCODE_VCD)) {
    statusSteps = [
       {name: CommercialOrderStatus.OrderPlaced, label: OrderStatusBarComponent.ORDER_PLACED_LABEL, icon: OrderStatusBarComponent.FILE_MEDICAL_ICON },
       {name: CommercialOrderStatus.SampleCollected, label: OrderStatusBarComponent.SAMPLE_COLLECTED_LABEL, icon: OrderStatusBarComponent.TRUCK_DROPLET_ICON},
       {name: CommercialOrderStatus.SampleReceivedAtLab, label: OrderStatusBarComponent.SAMPLE_RECEIVED_AT_LAB_LABEL, icon: OrderStatusBarComponent.FLASK_VIAL_ICON},
       {name: `${this.UpdateLastStatusLabel(status)}`, label:`${this.UpdateLastStatusLabel(status)}` , icon: OrderStatusBarComponent.FILE_LINES_ICON}
     ];
   } else if (drawChoice?.toLowerCase() === DrawChoice.TransplantGenomicsToScheduleDraw.toLowerCase()) {
     statusSteps = [
       {name: CommercialOrderStatus.OrderPlaced, label: OrderStatusBarComponent.ORDER_PLACED_LABEL,icon: OrderStatusBarComponent.FILE_MEDICAL_ICON},
       {name: CommercialOrderStatus.MobileDrawSchedulePending, label: OrderStatusBarComponent.MOBILE_DRAW_SCHEDULE_PENDING_LABEL, icon: "fa-solid fa-syringe"},
       {name: CommercialOrderStatus.SampleCollected, label: OrderStatusBarComponent.SAMPLE_COLLECTED_LABEL, icon: OrderStatusBarComponent.TRUCK_DROPLET_ICON},
       {name: CommercialOrderStatus.SampleReceivedAtLab, label: OrderStatusBarComponent.SAMPLE_RECEIVED_AT_LAB_LABEL, icon: OrderStatusBarComponent.FLASK_VIAL_ICON},
       {name: `${this.UpdateLastStatusLabel(status)}`, label:`${this.UpdateLastStatusLabel(status)}` , icon: OrderStatusBarComponent.FILE_LINES_ICON}
     ];
   } else if (drawChoice?.toLowerCase() === DrawChoice.ThirdPartyDraw.toLowerCase()) {
     statusSteps = [
       {name: CommercialOrderStatus.OrderPlaced, label: OrderStatusBarComponent.ORDER_PLACED_LABEL, icon: OrderStatusBarComponent.FILE_MEDICAL_ICON},
       {name: CommercialOrderStatus.ThirdPartyDrawPending, label: OrderStatusBarComponent.THIRD_PARTY_DRAW_PENDING_LABEL, icon: "fa-solid fa-house-chimney-medical"},
       {name: CommercialOrderStatus.SampleCollected, label: OrderStatusBarComponent.SAMPLE_COLLECTED_LABEL, icon: OrderStatusBarComponent.TRUCK_DROPLET_ICON},
       {name: CommercialOrderStatus.SampleReceivedAtLab, label: OrderStatusBarComponent.SAMPLE_RECEIVED_AT_LAB_LABEL, icon: OrderStatusBarComponent.FLASK_VIAL_ICON},
       {name: `${this.UpdateLastStatusLabel(status)}`, label:`${this.UpdateLastStatusLabel(status)}` , icon: OrderStatusBarComponent.FILE_LINES_ICON}
     ];
   }
   return statusSteps;
 }
 
 UpdateLastStatusLabel(currentStatus: string){
  let status='';
    switch(currentStatus)
    {
      case "Resulted":
        status = "Resulted";
        break;
      case "Cancelled":
        status = "Cancelled";
        break;
      default: status= "Resulted";
    }
  return status;
  }

   UpdateCompletedStatus(currentStatus: string){
    return currentStatus === CommercialOrderStatus.Completed ? "Resulted" : currentStatus;
  }


  isFieldNullOrEmpty(data: string){
    if(data === null || data.trim() === ''){
      return true;
    }
    return false;
  }
}
